import { getAvailableRiskTypes, getRiskShortLabel } from '../constants/riskTypes';

export function buildHitTabKey(hit) {
  const riskNumber = hit?.risk_number ?? 'unknown';
  const counterSerial =
    hit?.facts?.counter_serial_number || hit?.facts?.serial_number || hit?.entity_id;
  return `${riskNumber}:${counterSerial}:${hit?.entity_id}`;
}

export function buildEmptyTabKey(riskNumber) {
  return `empty:${riskNumber}`;
}

/** One slot per available risk; missing risks get an empty placeholder. */
export function buildCaseTabSlots(hits) {
  const list = Array.isArray(hits) ? hits : [];
  const slots = [];

  for (const risk of getAvailableRiskTypes()) {
    const riskNumber = Number(risk.id);
    const riskHits = list.filter((hit) => Number(hit.risk_number) === riskNumber);
    if (riskHits.length === 0) {
      slots.push({ empty: true, riskNumber, hit: null });
    } else {
      for (const hit of riskHits) {
        slots.push({ empty: false, riskNumber, hit });
      }
    }
  }

  return slots;
}

export function buildSlotTabKey(slot) {
  if (!slot) {
    return '';
  }
  if (slot.empty) {
    return buildEmptyTabKey(slot.riskNumber);
  }
  return buildHitTabKey(slot.hit);
}

export function pickDefaultSlotKey(slots, pickDefaultHitIndex) {
  if (!slots.length) {
    return '';
  }
  const hitSlots = slots.filter((slot) => !slot.empty && slot.hit);
  if (hitSlots.length === 0) {
    return buildSlotTabKey(slots[0]);
  }
  const bestIndex = pickDefaultHitIndex(hitSlots.map((slot) => slot.hit));
  return buildSlotTabKey(hitSlots[bestIndex]);
}

/**
 * Child rows under the main table row: one row per hit, grouped by risk #1–#4.
 * Several #2 counters → several #2 rows (distinguish by counter serial in cells).
 */
export function buildCaseExpandSlots(hits, _maxHit) {
  return buildCaseTabSlots(hits);
}

export function buildEmptyHitRowLabel(riskNumber) {
  return `#${riskNumber} ${getRiskShortLabel(Number(riskNumber))}`;
}

export function buildEmptyHitRowCells(riskNumber) {
  return {
    serial: '—',
    connection: '—',
    firmware: '—',
    schedule: '—',
    scheduleTitle: 'Нет срабатывания по этому риску',
    integrations: '—',
    hasComment: false,
    riskLevel: '—',
    score: '—',
    overdue: '—',
    missedTx: '—',
    missedTxTitle: '',
    empty: true,
    riskNumber,
  };
}
